document.addEventListener("turbo:load", function() {
  $('form').submit(function() {
    $(this).find('input.betrag').each(function() {
      $(this).parseNumber();
    });
  });
});
